import "src/decidim/collaborative_texts/init_documents";
require.context("../images", true);
import "stylesheets/decidim/collaborative_texts/collaborative_texts.scss";
